<template>
    <b-overlay :show="loading || typeLoading" opacity="0.2">
        <b-card no-body class="p-1">
            <div class="row align-items-end">
                <div class="col-md-4 mb-1 mb-md-0">
                    <label class="form-label">Şube</label>
                    <v-select-list :options="branches" :disabled="(branches || []).length == 0 || (branches || []).length == 1" label="Name" v-model="branch" placeholder="Şube"></v-select-list>
                </div>
                <div class="col-md-4 mb-1 mb-md-0">
                    <label class="form-label">Tarih</label>
                    <v-date-picker v-model="date" placeholder="Tarih"></v-date-picker>
                </div>
                <div class="col-md-auto mb-1 mb-md-0">
                    <button class="btn btn-success btn-block" :disabled="!branch" v-on:click="getCheckInserts">
                        Sorgula
                    </button>
                </div>
            </div>
            <div class="mt-75">
                <div class="type rounded px-50 py-25 d-flex align-items-center d-inline-flex m-25" :class="`type-bg-${type.Color}`" v-for="type in types" :key="type.Code">
                    <div class="d-flex align-items-center justify-content-center font-weight-bolder mr-50" :class="`type-${type.Color}`">{{type.Code}}</div>
                    <span class="pr-25">{{type.Name}}</span>
                </div>
            </div>
            <div class="alert alert-danger mb-0 mt-75" v-if="message">
                <div class="alert-body">{{ message }}</div> 
            </div>
            <template v-else>
                <div class="alert alert-primary mb-0 mt-75" v-if="!lastBranch && !(inserts || []).length">
                    <div class="alert-body">Günlük puantaj takibi için <strong>gün</strong> ve <strong>şube</strong> seçmelisiniz ve sorgulamalısınız.</div>
                </div>
                <div class="alert alert-warning mb-0 mt-75" v-else-if="lastBranch && !(inserts || []).length">
                    <div class="alert-body">Seçilen şube <strong>({{ $safe(branch,'Name') }})</strong> ve tarih <strong>({{ c_date }})</strong> için takip verisi bulunamadı.</div>
                </div>
                <template v-else>
                    <vue-perfect-scrollbar v-if="c_stats">
                        <table class="table table-header table-bordered bordered-header table-sm mt-1">
                            <thead>
                                <tr>
                                    <th class="w-20">Unvan</th>
                                    <th class="w-20">Girilen Günlük Puantaj</th>
                                    <th class="w-20">Toplam Personel</th>
                                    <th class="w-20">Yüzdelik (%)</th>
                                    <th class="w-20">İlerleme</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(stat,index) in c_stats" :key="index">
                                    <td>{{$safe(stat,'Name') || '-'}}</td>
                                    <td>{{$safe(stat,'Inserted') || '0'}}</td>
                                    <td>{{$safe(stat,'Total') || '0'}}</td>
                                    <td>{{$safe(stat,'Percent')||'0.00'}}%</td>
                                    <td>
                                        <b-progress height="1.5rem" striped :variant="$safe(stat,'Status')" :value="$safe(stat,'Percent')||'0.00'"></b-progress>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </vue-perfect-scrollbar>
                    <div class="alert alert-primary mb-0 mt-1" v-if="c_responsible">
                        <div class="alert-body">
                            <b>Sorumlu Personeller:</b> {{c_responsible}}
                        </div>
                    </div>
                    <div class="card-columns">
                        <template v-for="insert in inserts">
                            <div :key="$safe(insert,'Garage.Id')">
                                <vue-perfect-scrollbar >
                                    <table class="table table-sm table-bordered mt-75" >
                                        <thead>
                                            <tr>
                                                <th class="bg-light-secondary"><span class="font-weight-bolder mb-0 h3 text-secondary py-25">{{$safe(insert,'EmployeeDepartment.Name')}}</span></th>
                                                <th class="align-middle text-center">{{getRatio(insert)}}</th>
                                            </tr>
                                            <tr>
                                                <th class="w-100">Personel</th>
                                                <th>Durum</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(dst) in insert.DriverScoreTasks" :key="$safe(dst,'Employee.Id')" :class="{'bg-light-danger':$safe(dst,'EmployeeWorkingType') == null}">
                                                <td class="text-nowrap">{{$safe(dst,'Employee.FullName')}}</td>
                                                <td class="text-nowrap text-center font-weight-bolder" :class="getColor(dst.EmployeeWorkingType)">{{$safe(dst,'EmployeeWorkingType.Code') || '-'}}</td>
                                            </tr>
                                            <tr v-if="!(insert.DriverScoreTasks || []).length">
                                                <td class="text-center" colspan="2">Henüz bir veri bulunmamaktadır.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </vue-perfect-scrollbar>
                            </div>
                        </template>
                    </div>
                </template>
            </template>
        </b-card>
    </b-overlay>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import CompanyApi from '@/api/company'
import { BCard,BOverlay,BProgress } from 'bootstrap-vue'
import moment from 'moment'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    components:{
        BCard,
        VuePerfectScrollbar,
        BOverlay,
        BProgress,
    },
    data() {
        return {
            date:moment().locale('tr').format('YYYY-MM-DD'),
            inserts:[],
            message:null,
            branches:[],
            branch:null,
            loading:false,
            lastBranch:null,
            types:[],
            typeLoading:false,
        }
    },
    mounted(){
        this.getBranches()
        this.getWorkingTypes()
    },
    methods:{
        getWorkingTypes(){
            return new Promise(resolve=>{
                this.typeLoading = true
                EmployeeOperationsApi.Score.WorkingType().then(res=>{
                    this.typeLoading = false
                    this.types = res.data.Data
                    resolve()
                }).catch(err=>{ this.typeLoading = false })
            })
        },
        getColor(e){
            return 'type-' + e?.Color || null
        },
        getRatio(i){
            if((i.DriverScoreTasks || []).length){
                let emptyWorkingTypesLength = i.DriverScoreTasks.filter(d=>d.EmployeeWorkingType != null).length
                return [emptyWorkingTypesLength,i.DriverScoreTasks.length].join('/')
            }else return "-"
        }, 
        getCheckInserts(){
            if(this.branch){
                this.loading = true
                EmployeeOperationsApi.Score.CheckInsert(this.date,this.branch.Id,true).then(res=>{
                    this.inserts = res.data.Data
                    this.message = res.data.Message
                    this.loading = false
                    this.lastBranch = this.branch
                }).catch(()=>this.loading = false)
            }
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                if(res.data.Success){
                    this.branches = res.data.Data
                    if((this.branches || []).length == 1){
                        this.branch = res.data.Data[0]
                    }
                } else { this.$result(res) }
            })
        },
    },
    computed:{
        c_date(){
            return moment(this.date,'YYYY-MM-DD').locale('tr').format('DD.MM.YYYY')
        },
        c_stats(){
            if(this.inserts && this.inserts?.length){
                return this.inserts?.map(i=>{
                    let total = i.DriverScoreTasks?.length || 0
                    let inserted = i.DriverScoreTasks?.filter(d=>d.EmployeeWorkingType != null).length || 0
                    let percent = total > 0 ? (inserted * 100 / total).toFixed(2) : '0.00'
                    return {
                        Name:i.EmployeeDepartment?.Name || '',
                        Total:total,
                        Inserted:inserted,
                        Percent:percent,
                        Status: Number(percent) < 100 ? 'secondary' : 'success'
                    }
                }) || []
            }else return []
        },
        c_responsible(){
            return this.inserts?.map(r=>r.HRResponsibleEmployees).filter(r=>r)[0] || ""
        }
    }
}
</script>

<style lang="scss">
@use "sass:map";

$types-bg:(
    'indigo': #8888ca,
    'pink': #a17191,
    'green': #83974a,
    'purple': #9a779b,
    'light-orange': #c1aca8,
    'dark-green': #9a997e,
    'yellow': #c7bf41,
    'red': #bc797e,
    'clean': #ffffff,
    'orange': #a87a4e,
    'teal': #8cbde5,
    'blue': #46b5d4,
    'gray': #9ea3c0,
);

$types-color:(
    'indigo': hsl(240, 38%, 33%),
    'pink': hsl(320, 20%, 21%),
    'green': hsl(76, 34%, 11%),
    'purple': hsl(298, 15%, 21%),
    'light-orange': hsl(10, 17%, 38%),
    'dark-green': hsl(58, 12%, 21%),
    'yellow': hsl(56, 54%, 19%),
    'red': hsl(356, 33%, 28%),
    'clean': hsl(0, 0%, 0%),
    'orange': hsl(29, 37%, 15%),
    'teal': hsl(207, 63%, 38%),
    'blue': hsl(193, 62%, 22%),
    'gray': hsl(231, 21%, 36%),
);

$types-bg-color:(
    'indigo': hsl(240, 38%, 65%),
    'pink': hsl(320, 20%, 53%),
    'green': hsl(76, 34%, 43%),
    'purple': hsl(298, 15%, 53%),
    'light-orange': hsl(10, 17%, 60%),
    'dark-green': hsl(58, 12%, 53%),
    'yellow': hsl(56, 54%, 51%),
    'red': hsl(356, 33%, 60%),
    'clean': hsl(0, 0%, 62%),
    'orange': hsl(29, 37%, 55%),
    'teal': hsl(207, 63%, 65%),
    'blue': hsl(193, 62%, 60%),
    'gray': hsl(231, 21%, 63%),
);

.type > div{
    height: 25px;
    width: 25px;
    border-radius: 100%;
    min-width: 25px;
    font-size: 0.85rem;
}



.today-icon{
    font-size: 4.5rem;
}

@each $class,$color in $types-bg{
    .type-#{$class}{
        background-color: $color;
        color: map.get($types-color,$class)
    }
    .type-bg-#{$class}{
        background-color: lighten(map.get($types-bg-color,$class), 30%);
        color: map.get($types-color,$class) !important;
    }
};
</style>